<!--
 * @Author: cn1994
 * @Date: 2023-01-17 10:47:54
 * @LastEditors: chenw wchen@lingshi.com
 * @LastEditTime: 2025-03-29 19:22:35
 * @Description: 登陆页面
-->
<template>
  <div class="ls-login-container">
    <div class="login-control-panel">
      <div class="left-bgimage"></div>
      <div class="account-login-panel" v-if="loginType != 'qrCode'">
        <!-- 二维码扫码登录 -->
        <div class="welcome-text flex items-center">欢迎使用管理后台</div>
        <el-tabs
          class="custom-tabs"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane label="账号登录" name="account">
            <div class="account-login-form-wrap">
              <el-form :model="formData" ref="accountForm" :rules="rules">
                <el-form-item prop="username">
                  <el-input
                    class="custom-input"
                    placeholder="请输入账号"
                    clearable
                    v-model="formData.username"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="pwd">
                  <el-input
                    class="custom-input"
                    placeholder="请输入密码"
                    clearable
                    :type="pwdInputType"
                    maxlength="20"
                    v-model="formData.pwd"
                  >
                    <i
                      class="iconfont icontyan"
                      :class="pwdVsisbleIcon"
                      slot="suffix"
                      @click="pwdVisible"
                    >
                    </i>
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="smsCode">
            <div class="code-login-form-wrap">
              <el-form :model="smsFormData" ref="smsCodeForm" :rules="rules">
                <el-form-item prop="mobile">
                  <el-input
                    class="custom-input"
                    placeholder="请输入手机号"
                    clearable
                    v-model="smsFormData.mobile"
                    @change="mobileChange"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="smsCode">
                  <el-input
                    class="custom-input"
                    placeholder="请输入验证码"
                    :maxlength="6"
                    v-model="smsFormData.smsCode"
                    @change="smsCodeChange"
                  >
                    <div slot="suffix" class="get-code-cell">
                      <span
                        :class="getCodeBtnClass"
                        class="get-code-text"
                        @click="debounceGetSMSCode"
                        >{{ getCodeText }}</span
                      >
                    </div>
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="submit-wrap">
          <el-button
            class="custom-btn"
            type="primary"
            @click="submit"
            :loading="submitLoading"
            >登 录</el-button
          >
        </div>
        <div class="login-mode-computer">
          <div class="desk" @click="loginComputer">
            <img :src="$urls.loginComputer" alt="" />
            <p>保存至桌面</p>
          </div>
          <div class="loginFile" @click="setDialogFile = true">
            <img :src="$urls.loginFile" alt="" />
            <p>添加至收藏夹</p>
          </div>
        </div>
        <div class="divider-text" v-if="showUrl">
          <el-divider content-position="center">其他方式登录</el-divider>
        </div>
        <div class="login-mode-cell" v-if="showUrl">
          <div class="appLogin" @click="qrCodeClick('open')">
            <i class="iconfont icon-iconfontscan"></i>
            <p>App扫码登录</p>
          </div>
          <!-- <div class="wechat-login" @click="wxworkLogin">
            <img class="wxwork" :src="$urls.wechatImagelogin" alt="" />
            <p>企业微信登录</p>
          </div> -->
        </div>
      </div>
      <div
        class="qr-code-login-panel"
        v-if="loginType == 'qrCode' && !qrCodeScanPanelVisible"
      >
        <div class="guide-text">
          <p class="title">App扫码登录</p>
        </div>
        <div class="qr-cpde-content">
          <div class="qr-code-wrap" v-if="qrCodeData.qrCodeKey">
            <img class="qr-code-img" v-if="qrCodeUrl" :src="qrCodeUrl" alt="" />
            <VueQrcode
              :value="qrCodeData.qrCodeKey"
              type="image/png"
              :color="{ dark: '#000000ff', light: '#ffffffff' }"
              :margin="0"
              @change="generateQrCode"
            />
          </div>
        </div>
        <div class="login-edit">
          <el-divider content-position="center">其他方式登录</el-divider>
        </div>
        <div class="login-other">
          <div class="login-one" @click="qrCodeClick('account')">
            <i class="icon el-icon-monitor"></i>
            <p>账号登录</p>
          </div>
          <div class="login-two" @click="qrCodeClick('smsCode')">
            <i class="icon el-icon-mobile-phone"></i>
            <p>验证码登录</p>
          </div>
          <!-- <div class="login-three" @click="wxworkLogin">
            <img :src="$urls.wechatImagelogin" alt="" />
            <p>企业微信登录</p>
          </div> -->
        </div>
      </div>
      <!-- 扫码状态渲染 -->
      <div class="qr-code-login-scan-panel" v-if="qrCodeScanPanelVisible">
        <!-- 成功 -->
        <div class="success-cell" v-if="qrCodeData.qrCodeStatus == 'waiting'">
          <i class="iconfont icon-chenggongtishi"></i>
          <span class="status">扫码成功</span>
          <span class="des">请在App中点击登录</span>
        </div>
        <!-- 失败 -->
        <div class="fail-cell" v-if="qrCodeData.qrCodeStatus == 'fail'">
          <i class="iconfont icon-shibaitishi"></i>
          <span class="status">本次登录失败，请重试</span>
          <span class="retry" @click="retry">重试</span>
        </div>
        <!-- 取消 -->
        <div class="fail-cell" v-if="qrCodeData.qrCodeStatus == 'cancel'">
          <i class="iconfont icon-shibaitishi"></i>
          <span class="status">你已取消此次登录</span>
          <span class="retry" @click="retry">重试</span>
        </div>
        <!-- 过期 -->
        <div
          class="qr-code-login-panelB"
          v-if="qrCodeData.qrCodeStatus == 'expired'"
        >
          <div class="guide-text">
            <p class="title">App扫码登录</p>
          </div>
          <div class="qr-cpde-content">
            <div class="qr-code-wrap" v-if="qrCodeData.qrCodeKey">
              <img
                class="qr-code-img"
                v-if="qrCodeUrl"
                :src="qrCodeUrl"
                alt=""
              />
              <VueQrcode
                :value="qrCodeData.qrCodeKey"
                type="image/png"
                :color="{ dark: '#000000ff', light: '#ffffffff' }"
                :margin="0"
                @change="generateQrCode"
              />
            </div>
            <div class="qr-code-wrapA">
              <div class="text-content">二维码已过期，</div>
              <div class="text-refesh" @click="retry">刷新</div>
            </div>
          </div>
          <div class="login-edit">
            <el-divider content-position="center">其他方式登录</el-divider>
          </div>
          <div class="login-other">
            <div class="login-one" @click="qrCodeClick('account')">
              <i class="icon el-icon-monitor"></i>
              <p>账号登录</p>
            </div>
            <div class="login-two" @click="qrCodeClick('smsCode')">
              <i class="icon el-icon-mobile-phone"></i>
              <p>验证码登录</p>
            </div>
            <div class="login-three" @click="wxworkLogin">
              <img :src="$urls.wechatImagelogin" alt="" />
              <p>企业微信登录</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关停账号提示弹窗 -->
    <ImageDialog :visible="showWechatCode" @cancel="showWechatCode = false">
      <div
        slot="content"
        class="config-content-modal flex items-center rounded-[16px] bg-[#fff]"
      >
        <div class="flex justify-center">
          <img :src="$urls.loginLingShiYunQr" alt="" />
          <span class="text-[#333] text-[16px] mt-[20px] font-[500]"
            >当前服务已暂停，如有待付账单请微信扫码缴费后继续使用<br />若有疑问请联系运营经理</span
          >
        </div>
      </div>
    </ImageDialog>
    <el-dialog
      :visible.sync="setDialogFile"
      width="600px"
      :hasCancelBtn="false"
      :hasCancelOk="false"
      @confirm="setDialogFile = false"
      class="customdialog"
    >
      <div class="customdialog-content">
        <div class="text-[#333] text-[16px]">
          同时按下Ctrl+D，将管理后台添加至收收藏夹！
        </div>
        <div class="knowClick flex items-center justify-center" @click="setDialogFile = false">
          我知道了
        </div>
      </div>
    </el-dialog>
    <div class="dev-select-server" v-if="isDev">
      <el-select v-model="serverSelected" size="small" placeholder="请选择登陆环境">
        <el-option
          v-for="item in serverKeys"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<!--
  二维码状态枚举
  create = 创建
  waiting = 已扫码未操作
  done = 已扫码并成功结束
  cancel = 已扫码取消
  fail = 已扫码失败
  expired = 已过期
-->

<script>
import loginApis from "@/apis/login";
import beginApis from "@/apis/begin";
import { Message } from "element-ui";
import lodash from "lodash";
import VueQrcode from "vue-qrcode";
import verify from "./verify";
import ImageDialog from "@/components/imageDialog/index.vue";
import { useBaseStore } from "@/stores/base";
import { useMenuStore } from "@/stores/menu";
import specialInst from "@/mixin/specialInst"
import { useMedicalStore } from "@/stores/medical";
const baseStore = useBaseStore();
const menuStore = useMenuStore();
const medicalStore = useMedicalStore();
import { ossDomains } from "@/config/domains";

export default {
  components: {
    VueQrcode,
    ImageDialog,
  },
  mixins: [specialInst],
  data() {
    const checkMobileBind = (rule, value, callback) => {
      if (this.mobileNotBind) {
        return callback(new Error("当前手机号未注册,请使用账号密码登录！"));
      }
      return callback();
    };
    //退出再次登录小于1分钟的错误提示
    const checkMobileBindAgine = (rule, value, callback) => {
      if (this.mobileAgine) {
        return callback(
          new Error("短信发送频率超过限制（1分钟之内最多发送一条）")
        );
      }
      return callback();
    };
    const checkSMSCodeFiald = (rule, value, callback) => {
      if (this.smsCodeFiald) {
        return callback(new Error("验证码错误，请输入正确的验证码！"));
      }
      return callback();
    };
    this.debounceGetSMSCode = lodash.throttle(this.getCodeFn, 1000, {
      leading: true,
    });
    return {
      verify,
      rules: {
        username: [{ validator: verify.checkUsername, trigger: "blur" }],
        pwd: [{ validator: verify.checkPwd, trigger: "blur" }],
        verifyCode: [{ validator: verify.checkCerifyCode, trigger: "blur" }],
        mobile: [
          { validator: verify.checkMobile, trigger: "blur" },
          { validator: checkMobileBind, trigger: "blur" },
          { validator: checkMobileBindAgine, trigger: "blur" },
        ],
        smsCode: [
          { validator: verify.checkSMSCode, trigger: "blur" },
          { validator: checkSMSCodeFiald, trigger: "blur" },
        ],
      },
      formData: {
        username: "", // 用户名
        pwd: "", // 密码
        verifyCode: "", // 密码错误5次之后的验证码
      },
      smsFormData: {
        mobile: "",
        smsCode: "",
      },
      activeName: "account",
      loginErrorNum: 0,
      verifyCodeImgUrl: "", // 图片验证码地址
      firstGetCode: true,
      getCodeInterval: null,
      getCodeCountDown: 60,
      getCodeCountDownStatus: false, // 是否开始倒计时，true开始，false结束
      loginType: "account", // 账号登录=account,手机验证码登录=smsCode，扫码登陆=qrCode
      mobileNotBind: false,
      mobileAgine: false, //再次登录
      qrCodeData: "", // 存储二维码信息
      pollingObject: "", // 存储轮询对象
      qrCodeUrl: "", // 二维码url
      smsCodeFiald: false,
      // bindMobileVisible: false,
      loginResult: "",
      submitLoading: false,
      pwdInputType: "password",
      showWechatCode: false, // 关停客户弹窗
      setDialogFile: false,
      serverSelected: 'stage2ossm'
    };
  },
  computed: {
    getCodeText() {
      if (this.firstGetCode) {
        return "获取验证码";
      } else {
        if (this.getCodeCountDownStatus) {
          return `重新获取（${this.getCodeCountDown}秒）`;
        } else {
          return `重新获取`;
        }
      }
    },
    getCodeBtnClass() {
      if (this.getCodeCountDownStatus) {
        return "disabled";
      } else {
        return "";
      }
    },
    getTagText() {
      if (this.loginType != "qrCode") {
        return "App扫码登录更方便";
      } else {
        return "使用密码或验证码登录";
      }
    },
    qrCodeScanPanelVisible() {
      if (this.qrCodeData && this.qrCodeData.qrCodeStatus != "create") {
        return true;
      } else {
        return false;
      }
    },
    pwdVsisbleIcon() {
      if (this.pwdInputType == "password") {
        return "icon-yanjing-guan";
      } else {
        return "icon-yanjing-kai";
      }
    },
    showUrl() {
      const url = window.location.host;
      // 隐藏hostArray其他方式登录
      const hostArray = [
        "wxb.lingshi.com",
        "wxbgc.lingshi.com",
        "ylxsmanagement.lingshi.com",
        "ylvsmanagement.lingshi.com"
      ];
      if (hostArray.includes(url)) {
        return false;
      } else {
        return true;
      }
    },
    isDev() {
      if (process.env.NODE_ENV === "development") {
        return true
      } else {
        return false
      }
    },
    serverKeys() {
      return Object.keys(ossDomains)
    }
  },
  watch: {
    loginType: function (data) {
      if (data == "qrCode") {
        this.getLoginQrcode();
      } else {
        clearInterval(this.pollingObject);
      }
      if (this.$refs["accountForm"]) {
        this.$refs["accountForm"].clearValidate();
      }
      if (this.$refs["smsCodeForm"]) {
        this.$refs["smsCodeForm"].clearValidate();
      }
    },
    serverSelected(value) {
      baseStore.setDevelopEnv(value)
    }
  },
  created() {
    let _this = this;
    document.onkeydown = function (key) {
      if (
        key.code == "Enter" &&
        _this.loginType != "qrCode" &&
        !key.isComposing
      ) {
        // 回车事件
        _this.submit();
      }
    };
  },
  mounted() {
    baseStore.setDevelopEnv(this.serverSelected)
  },
  destroyed() {
    document.onkeydown = null;
  },
  methods: {
    loginComputer() {
      window.location.href = `${baseStore.baseDomain}/index.php?g=Headmaster&m=api&a=getOssUrl`;
    },
    handleClick(data) {
      this.loginType = data.name;
      this.$refs["accountForm"].clearValidate();
      this.$refs["smsCodeForm"].clearValidate();
    },
    getSMSCode() {
      return new Promise((resolve) => {
        const params = {
          phone: this.smsFormData.mobile,
          smsType: "login",
        };
        loginApis.getSMSCode(params).then((res) => {
          if (res.code == 0) {
            resolve(true);
          } else if (res.code == "-8001") {
            Message.error(res.message);
            resolve(false);
          } else if (res.code == "-6100") {
            this.mobileAgine = true;
            this.$refs["smsCodeForm"].validateField("mobile");
            resolve(false);
          } else {
            this.mobileNotBind = true;
            this.$refs["smsCodeForm"].validateField("mobile");
            resolve(false);
          }
        });
      });
    },
    async getCodeFn() {
      if (this.getCodeCountDownStatus) return;
      this.$refs["smsCodeForm"].validateField("mobile", async (valid) => {
        if (!valid) {
          this.firstGetCode = false;
          const smsResult = await this.getSMSCode();
          if (smsResult) {
            this.startCountDown();
          }
        }
      });
    },
    startCountDown() {
      this.getCodeCountDownStatus = true;
      this.getCodeInterval = setInterval(() => {
        this.getCodeCountDown -= 1;
        if (this.getCodeCountDown == 0) {
          clearInterval(this.getCodeInterval);
          this.getCodeCountDownStatus = false;
          this.getCodeCountDown = 60;
        }
      }, 1000);
    },
    submit() {
      if (this.activeName == "account") {
        this.$refs["accountForm"].validate((valid) => {
          if (valid) {
            this.login();
          }
        });
      } else if (this.activeName == "smsCode") {
        this.$refs["smsCodeForm"].validate((valid) => {
          if (valid) {
            this.login();
          }
        });
      }
    },
    login() {
      this.submitLoading = true;
      let params = {};
      if (this.activeName == "account") {
        params = {
          method: "account",
          userName: this.formData.username,
          password: this.formData.pwd,
          server: null,
        };
        if (this.isSpecialInst(this.formData.username)) {
          params.server = this.serverLink;
        }
      } else if (this.activeName == "smsCode") {
        params = {
          method: "mobile",
          phone: this.smsFormData.mobile,
          smsCode: this.smsFormData.smsCode,
        };
      }
      loginApis.accountLogin(params).then(async(res) => {
        if (res.code == 0) {
          let sessionData = res.sessionData;
          const host = location.host.split(".");
          const domain = host[1] + "." + host[2]
          const expires = '60*60*24*7'
          this.$cookies.set("token", sessionData.userInfo.token, expires, '/', domain)
          this.$cookies.set("instId", sessionData.userInfo.inst_id, expires, '/', domain)
          this.$cookies.set("dcpDomain", sessionData.userInfo.domain, expires, '/', domain)
          baseStore.init(sessionData);
          this.getInstConfigData(sessionData.userInfo.mainCampusId); // 获取机构配置
          let schoolsAndCourses = sessionData.myProfile.schoolsAndCourses;
          // 科目管理员直接进首页
          if (sessionData.userInfo.adminRole == "3") {
            menuStore.updateMenuList([]);
            this.$router.push({
              path: "/home",
            });
            return;
          }
          // 特殊机构
          if (this.isSpecialInst(this.formData.username)) {
            localStorage.setItem('username', this.formData.username);
            localStorage.setItem('pwd', this.formData.pwd);
            this.$router.push({
              path: '/begin/server'
            })
            return;
          }
          //如果机构是外教机构，直接进入外教管理
          if(baseStore.LSforeign){
            this.$router.push({
              path: '/foreignManage'
            })
            return;
          }
          if( sessionData.isLogin == 1 && sessionData.lastLoginInfo != ''){
            this.switchInst(sessionData.lastLoginInfo)
            return;
          }
          if (schoolsAndCourses.length > 1) {
            this.$router.push({
              path: "/begin/campus",
            });
          } else if (
            (schoolsAndCourses.length == 1 &&
              schoolsAndCourses[0].courses.length > 1) ||
            (schoolsAndCourses.courses && schoolsAndCourses.courses.length > 1)
          ) {
            menuStore.setcampusId(String(sessionData.userInfo.mainCourseId));
            this.$router.push({
              path: "/begin/subject",
              query: {
                adminRole: sessionData.userInfo.adminRole,
                campusId: sessionData.userInfo.mainCourseId,
              },
            });
          } else {
            menuStore.setcampusId(String(sessionData.userInfo.mainCourseId));
            menuStore.updateMenuList([]);
            this.$router.push({
              path: "/home",
            });
          }
        } else if (res.code == -1) {
          if (
            res.message ==
            "用户名或密码错误,请输入正确密码或在App登录页重置密码"
          ) {
            Message.error("用户名或密码错误");
          } else {
            Message.error(res.message);
          }
        } else if (res.code == -3) {
          this.showWechatCode = true;
        } else {
          Message.error(res.message);
        }
        this.submitLoading = false;
        // 登录清空医疗数据
        this.clearMedicalPageData();
      });
    },
    // 二维码登陆点击
    qrCodeClick(method) {
      if (method == "open") {
        this.loginType = "qrCode";
      } else {
        this.qrCodeData.qrCodeStatus = "create";
        this.loginType = method;
        this.activeName = method;
      }
    },
    mobileChange(value) {
      this.mobileNotBind = false;
      this.mobileAgine = false;
    },
    smsCodeChange(value) {
      let re = /^[0-9]{6}$/;
      if (!re.test(value)) {
        this.smsFormData.smsCode = "";
      }
      this.smsCodeFiald = false;
    },
    // 获取登陆二维码
    getLoginQrcode() {
      loginApis.getLoginQrcode().then((res) => {
        if (res.code == 0) {
          this.qrCodeData = res.qrCode;
          this.startPollingLoginQrcodeStatus();
        } else {
          Message.error(res.message);
        }
      });
    },
    // 查询二维码状态
    searchLoginQrcodeStatus() {
      return new Promise((resolve) => {
        const params = {
          qrKey: this.qrCodeData.qrCodeKey,
        };
        loginApis.searchLoginQrcodeStatus(params).then((res) => {
          if (res.code == 0) {
            resolve(res);
          } else {
            Message.error(res.message);
            resolve(false);
          }
        });
      });
    },
    async startPollingLoginQrcodeStatus() {
      clearInterval(this.pollingObject);
      // 间隔500毫秒查询一次状态
      const result = await this.searchLoginQrcodeStatus();
      if (result) {
        if (result.code == 0 && result.hasOwnProperty("sessionData")) {
          // 登陆成功
          let sessionData = result.sessionData;
          baseStore.init(sessionData);
          if(sessionData.userInfo && sessionData.userInfo.mainCampusId) {
            this.getInstConfigData(sessionData.userInfo.mainCampusId);
          }
          let schoolsAndCourses = sessionData.myProfile.schoolsAndCourses;
          // 科目管理员直接进首页
          if (sessionData.userInfo.adminRole == "3") {
            menuStore.updateMenuList([]);
            this.$router.push({
              path: "/home",
            });
            return;
          }
          if( sessionData.isLogin == 1 && sessionData.lastLoginInfo != ''){
            this.switchInst(sessionData.lastLoginInfo)
            return;
          }
          if (schoolsAndCourses.length > 1) {
            this.$router.push({
              path: "/begin/campus",
            });
          } else if (
            (schoolsAndCourses.length == 1 &&
              schoolsAndCourses[0].courses.length > 0) ||
            (schoolsAndCourses.courses && schoolsAndCourses.courses.length > 1)
          ) {
            menuStore.setcampusId(String(sessionData.userInfo.mainCourseId));
            this.$router.push({
              path: "/begin/subject",
              query: {
                adminRole: sessionData.userInfo.adminRole,
                campusId: sessionData.userInfo.mainCourseId,
              },
            });
          } else {
            menuStore.updateMenuList([]);
            this.$router.push({
              path: "/home",
            });
          }
        } else {
          this.qrCodeData = result.data;
          // 完成、取消、失败、过期状态停止轮询
          const endStatus = ["done", "cancel", "fail", "expired"];
          if (
            endStatus.includes(this.qrCodeData.qrCodeStatus) ||
            this.loginType != "qrCode"
          ) {
            return;
          }

          this.pollingObject = setTimeout(() => {
            this.startPollingLoginQrcodeStatus();
          }, 500);
        }
      }
    },
    // 重试
    retry() {
      // 扫码失败、过期等状态重新生成二维码
      this.getLoginQrcode();
    },
    // 生成二维码
    generateQrCode(data) {
      this.qrCodeUrl = data;
    },
    wxworkLogin() {
      let host = location.host;
      if (host.includes("buwebgc")) {
        window.location.href =
          "https://webgc.lingshi.com/index.php/qiwei/qiwei/loginUrl";
      } else if (host.includes("preossm")) {
        window.location.href =
          "https://xs.51tyty.com/srcm/index.php/qiwei/qiwei/loginUrl";
      } else if (host.includes("qipei") || host.includes("qipeigc")) {
        window.location.href =
          "https://corptrainm.lingshi.com/index.php/qiwei/qiwei/loginUrl";
      } else {
        window.location.href =
          "https://web.lingshi.com/index.php/qiwei/qiwei/loginUrl";
      }
    },
    pwdVisible() {
      if (this.pwdInputType == "password") {
        this.pwdInputType = "text";
      } else {
        this.pwdInputType = "password";
      }
    },
    clearMedicalPageData() {
      // 登录时置空数据
      // 清除医疗后台前端存储的数据
      medicalStore.clearAllPageAndSearchData();
      localStorage.removeItem("medical_patient_appointment");
    },
    //有上次的登录信息直接进入
    switchInst(data) {
      const params = {
        instId: data.instId,
        serverId: data.serverId,
        domain: data.domain,
        switchType: 1,
      };
      beginApis.switchInst(params).then((res) => {
        if (res.code == 0) {
          const host = location.host.split(".");
          const domain = '.' + host[1] + "." + host[2]
          const expires = '60*60*24*7'
          let sessionData = res.data.sessionData;
          this.$cookies.set("token", sessionData.userInfo.token, expires, '/', domain)
          this.$cookies.set("instId", sessionData.userInfo.inst_id, expires, '/', domain)
          this.$cookies.set("dcpDomain", sessionData.userInfo.domain, expires, '/', domain)
          sessionStorage.setItem("token", sessionData.userInfo.token);
          baseStore.init(sessionData);
          this.getInstConfigData(sessionData.userInfo.mainCampusId);
          menuStore.updateMenuList([]);
          this.$router.push({
            path: "/home",
          });
        } else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        
      });
    },
    // 获取机构配置信息-查看客户是否为内部客户-OSS
    getInstConfigData(instId) {
      beginApis.instConfigData({inst_id: instId}).then(instConfigRes => {
        if(instConfigRes.code == 0) {
          baseStore.updateIsInternal(instConfigRes.isInternal || false);
          baseStore.updateIndustryType(instConfigRes.industryType || 1);
        }
      })
    },   
  },
};
</script>

<style lang="less" scoped>
.ls-login-container {
  height: 100%;
  background-image: url("https://cdnws.51tyty.com/business/ossManagement/business_default_img/login.gif");
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-control-panel {
    display: flex;
    justify-content: space-around;
    width: 100%;

    .left-bgimage {
      width: 300px;
      height: auto;
    }
    .account-login-panel {
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
      border-radius: 12px;
      background-color: #fff;
      padding: 50px 56px;
      width: 480px;
      height: 574px;

      .welcome-text {
        color: #333333;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 22px;
      }

      /deep/.custom-tabs {
        .el-tabs__header {
          margin-bottom: 32px;
          .el-tabs__nav-wrap {
            padding-left: 0;
            &::after {
              display: none;
            }
          }
        }
        .el-tabs__active-bar {
          height: 2px;
        }

        .el-tabs__item {
          font-size: 18px;
          font-weight: normal;
          padding: 0;
          color: #333;
          margin-bottom: -5px;
          padding-right: 48px;
        }
        .el-tabs__item.is-active {
          color: #007aff;
          font-weight: 600;
          position: relative;
        }

        // .el-tabs__item.is-active::after {
        //   content: "";
        //   position: absolute;
        //   bottom: 5px;
        //   left: 0;
        //   right: 0;
        //   margin: 0 auto; /* 将下划线居中 */
        //   // border-radius: 3px;
        //   // width: 30px; /* 调整下划线的长度，可以根据需要进行调整 */
        //   height: 2px; /* 调整下划线的高度，可以根据需要进行调整 */
        //   background-color: #007aff; /* 调整下划线的颜色，可以根据需要进行调整 */
        // }
        .account-login-form-wrap,
        .code-login-form-wrap {
          .el-form-item {
            margin-bottom: 24px;
            .custom-input {
              .el-input__inner {
                padding-left: 20px;
                background: #f9fafb;
                border-radius: 6px;
                height: 54px;
                font-size: 14px;
              }
              .el-input__suffix {
                font-size: 28px;
                .el-input__suffix-inner {
                  line-height: 54px;
                }
              }
            }
            .iconfont {
              margin-right: 13px;
              font-size: 20px;
            }
          }
          .el-form-item {
            .el-form-item__content {
              .custom-input {
                .el-input__icon {
                  margin-right: 10px;
                  font-size: 20px; /* 自定义清除按钮的大小 */
                }
              }
            }
          }

          .el-form-item.is-error .el-input__inner {
            border-color: #ff5257;
            background: #fff3f3;
          }
          .el-form-item__error {
            padding-top: 0;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
          }
          .verify-code-cell {
            display: flex;
            align-items: center;
            .verify-img {
              margin-left: 10px;
            }
          }
        }

        .account-login-form-wrap {
          .el-input__prefix {
            display: flex;
            align-items: center;
            padding: 0 10px;
          }
        }

        .code-login-form-wrap {
          .get-code-cell {
            height: 100%;
            padding-right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            .get-code-text {
              color: #007aff;
              font-size: 14px;
              cursor: pointer;
            }
            .disabled {
              cursor: not-allowed;
              color: #999;
            }
          }
        }
      }

      .submit-wrap {
        width: 100%;
        display: flex;
        // margin-bottom: 56px;
        height: 54px;
        .custom-btn {
          flex: 1;
          font-size: 16px;
          color: #ffffff;
          font-weight: 500;
          background: linear-gradient(90deg, #295fff 0%, #007aff 100%);
          border-radius: 6px;
        }
      }
      .login-mode-computer {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        .desk {
          flex: 1;
          display: flex;
          justify-content: right;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
          }
          p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            margin-left: 6px;
          }
        }
        .loginFile {
          flex: 1;
          display: flex;
          justify-content: left;
          margin-left: 30px;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
          }
          p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            margin-left: 6px;
          }
        }
      }
      .divider-text {
        margin: 0 auto;
        margin-top: 44px;
        .el-divider {
          margin: 0;
          background-color: #e9e9e9;
          border-bottom: 1px dashed #dcdee0;
          .el-divider__text {
            font-size: 12px;
            color: #666666;
            font-weight: normal;
          }
        }
      }
      .login-mode-cell {
        display: flex;
        justify-content: center;
        margin-top: 30px;
        .appLogin {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
          }
          p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            margin-left: 6px;
          }
        }
        .wechat-login {
          flex: 1;
          display: flex;
          justify-content: left;
          margin-left: 30px;
          align-items: center;
          cursor: pointer;
          .wxwork {
            width: 16px;
            height: 16px;
          }
          p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            margin-left: 6px;
          }
        }
      }
    }

    .qr-code-login-panel {
      padding: 50px 56px;
      width: 480px;
      height: 574px;
      background-color: #fff;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
      border-radius: 12px;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      .guide-text {
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          font-size: 28px;
          color: #333;
          font-weight: 600;
        }
      }

      > .qr-cpde-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 68px;
        padding: 0 20px;
        margin-bottom: 82px;
        .qr-code-wrap {
          width: 220px;
          height: 220px;
          border-radius: 10px;
          border: 2px solid #e9e9e9;
          padding: 10px;
          .qr-code-img {
            width: 100%;
            height: 100%;
          }
        }
      }
      > .login-edit {
        width: 100%;
        margin: 0 auto;
        .el-divider {
          margin: 0;
          background-color: #e9e9e9;
          border-bottom: 1px dashed #dcdee0;
          .el-divider__text {
            font-size: 12px;
            color: #666666;
            font-weight: normal;
          }
        }
      }
      .login-other {
        display: flex;
        // justify-content: space-between;
        justify-content: center;
        margin-top: 40px;

        .login-one {
          display: flex;
          align-items: center;
          cursor: pointer;
          margin-right: 30px;
          .icon {
            font-size: 16px;
          }
          p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            margin-left: 6px;
          }
        }
        .login-two {
          display: flex;
          align-items: center;
          // margin: 0 30px;
          cursor: pointer;
          .icon {
            font-size: 16px;
          }
          p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            margin-left: 6px;
          }
        }
        .login-three {
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
          }
          p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            margin-left: 6px;
          }
        }
      }
    }
    .qr-code-login-scan-panel {
      padding: 50px 56px;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      width: 480px;
      height: 574px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 4;
      .success-cell {
        display: flex;
        flex-direction: column;
        align-items: center;

        .icon-chenggongtishi {
          color: #20d76d;
          font-size: 87px;
        }
        .status {
          color: #555;
          font-size: 20px;
          font-weight: 500;
        }
        .des {
          font-size: 18px;
          color: #555;
          margin-top: 10px;
        }
      }
      .qr-code-login-panelB {
        background-color: #fff;
        z-index: 5;
        display: flex;
        flex-direction: column;
        align-items: center;
        .guide-text {
          display: flex;
          flex-direction: column;
          align-items: center;
          .title {
            font-size: 28px;
            color: #333;
            font-weight: 600;
          }
        }

        > .qr-cpde-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 68px;
          padding: 0 20px;
          margin-bottom: 60px;
          .qr-code-wrap {
            position: relative;
            width: 220px;
            height: 220px;
            border-radius: 10px;
            border: 2px solid #e9e9e9;
            padding: 10px;
            opacity: 0.1;
            .qr-code-img {
              width: 100%;
              height: 100%;
            }
          }
          .qr-code-wrapA {
            position: absolute;
            width: 220px;
            height: 220px;
            border-radius: 10px;
            border: 2px solid #e9e9e9;
            padding: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            .text-content {
              font-size: 14px;
              color: #333333;
            }
            .text-refesh {
              font-size: 14px;
              color: #4f98fd;
              cursor: pointer;
            }
          }
        }
        > .login-edit {
          // width: 300px;
          width: 100%;
          margin: 0 auto;
          .el-divider {
            background-color: #e9e9e9;
            .el-divider__text {
              font-size: 14px;
              color: #666666;
              font-weight: normal;
            }
          }
        }
        .login-other {
          display: flex;
          justify-content: space-between;
          margin-top: 6px;
          .login-one {
            display: flex;
            align-items: center;
            cursor: pointer;
            .icon {
              font-size: 16px;
            }

            p {
              font-size: 14px;
              font-weight: normal;
              color: #666666;
              margin-left: 6px;
            }
          }
          .login-two {
            display: flex;
            align-items: center;
            margin: 0 30px;
            cursor: pointer;
            .icon {
              font-size: 16px;
            }
            p {
              font-size: 14px;
              font-weight: normal;
              color: #666666;
              margin-left: 6px;
            }
          }
          .login-three {
            display: flex;
            align-items: center;
            cursor: pointer;
            img {
              width: 19px;
              height: 16px;
            }
            p {
              font-size: 14px;
              font-weight: normal;
              color: #666666;
              margin-left: 6px;
            }
          }
        }
      }
      .fail-cell {
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon-shibaitishi {
          color: #ff8367;
          font-size: 87px;
        }
        .status {
          color: #555;
          font-size: 20px;
          font-weight: 500;
        }
        .retry {
          font-size: 18px;
          color: #007aff;
          margin-top: 10px;
          cursor: pointer;
        }
      }
    }
  }

  .config-content-modal {
    height: 445px;
    width: 460px;
    div {
      flex-wrap: wrap;
      img {
        width: 250px;
        height: 250px;
      }
      span {
        display: block;
        line-height: 26px;
        text-align: center;
      }
    }
  }
  .customdialog {
    /deep/.el-dialog {
      border-radius: 4px;
      .el-dialog__header {
        padding: 0;
        background-color: #fff !important;
      }
      .el-dialog__body {
        padding: 40px 20px;
      }
    }
    .customdialog-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .knowClick {
        width: 160px;
        height: 44px;
        background: linear-gradient(90deg, #295fff 0%, #007aff 100%);
        border-radius: 6px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        margin-top: 40px;
      }
    }
  }
}

/deep/.el-tabs__nav-wrap {
  padding-left: 0;
}

@media (max-width: 1280px) {
  .ls-login-container {
    .login-control-panel {
      .left-bgimage {
        width: 300px;
        height: auto;
      }
      .account-login-panel {
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px;
        background-color: #fff;
        padding: 38px 42px;
        width: 360px;
        height: 430px;

        .welcome-text {
          color: #333333;
          font-size: 21px;
          font-weight: 600;
          margin-bottom: 6px;
        }

        /deep/.custom-tabs {
          .el-tabs__header {
            margin-bottom: 15px;
            // .el-tabs__nav-wrap {
            //   padding-left: 0;
            //   &::after {
            //     display: none;
            //   }
            // }
          }
          .el-tabs__active-bar {
            height: 2px;
          }

          .el-tabs__item {
            font-size: 15px;
            // font-weight: normal;
            // color: #333;
            // padding: 0;
            // margin-bottom: -5px;
            // padding-right: 48px;
          }
          // .el-tabs__item.is-active {
          //   color: #007aff;
          //   font-weight: 600;
          //   position: relative;
          // }
          .account-login-form-wrap,
          .code-login-form-wrap {
            .el-form-item {
              margin-bottom: 22px;
              .custom-input {
                .el-input__inner {
                  // padding-left: 20px;
                  height: 40px;
                  font-size: 14px;
                }
                .el-input__suffix {
                  font-size: 28px;
                  .el-input__suffix-inner {
                    line-height: 40px;
                  }
                }
              }
              .iconfont {
                margin-right: 13px;
                font-size: 16px;
              }
            }
            .el-form-item {
              .el-form-item__content {
                .custom-input {
                  .el-input__icon {
                    margin-right: 10px;
                    font-size: 16px; /* 自定义清除按钮的大小 */
                  }
                }
              }
            }
            .el-form-item.is-error .el-input__inner {
              border-color: #ff5257;
              background: #fff3f3;
            }
            .el-form-item__error {
              font-size: 12px;
            }
            .verify-code-cell {
              display: flex;
              align-items: center;
              .verify-img {
                margin-left: 10px;
              }
            }
          }

          .account-login-form-wrap {
            .el-input__prefix {
              display: flex;
              align-items: center;
              padding: 0 10px;
            }
          }

          .code-login-form-wrap {
            .get-code-cell {
              height: 100%;
              padding-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              .get-code-text {
                color: #007aff;
                font-size: 14px;
                cursor: pointer;
              }
              .disabled {
                cursor: not-allowed;
                color: #999;
              }
            }
          }
        }

        .submit-wrap {
          width: 100%;
          display: flex;
          line-height: 40px;
          height: 40px;
          .custom-btn {
            flex: 1;
            font-size: 16px;
            color: #ffffff;
            font-weight: 500;
            background: linear-gradient(90deg, #295fff 0%, #007aff 100%);
            border-radius: 6px;
          }
        }
        .login-mode-computer {
          margin-top: 15px;
          .desk {
            img {
              width: 16px;
              height: 16px;
            }
            p {
              font-size: 14px;
              font-weight: normal;
              color: #333;
              margin-left: 6px;
            }
          }
          .loginFile {
            flex: 1;
            display: flex;
            justify-content: left;
            margin-left: 30px;
            align-items: center;
            cursor: pointer;
            img {
              width: 16px;
              height: 16px;
            }
            p {
              font-size: 14px;
              font-weight: normal;
              color: #333;
              margin-left: 6px;
            }
          }
        }
        .divider-text {
          margin: 0 auto;
          margin-top: 30px;
        }
        .login-mode-cell {
          margin-top: 25px;
          .appLogin {
            // flex: 1;
            // display: flex;
            // justify-content: right;
            // align-items: center;
            // cursor: pointer;
            img {
              width: 15px;
              height: 15px;
            }
            p {
              font-size: 12px;
              // font-weight: normal;
              // color: #666666;
              margin-left: 6px;
            }
          }
          .wechat-login {
            flex: 1;
            display: flex;
            justify-content: left;
            margin-left: 30px;
            align-items: center;
            cursor: pointer;
            .wxwork {
              width: 16px;
              height: 16px;
            }
            p {
              font-size: 12px;
              // font-weight: normal;
              // color: #666666;
              margin-left: 6px;
            }
          }
        }
      }

      .qr-code-login-panel {
        padding: 38px 42px;
        width: 360px;
        height: 430px;
        // background-color: #fff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
        // border-radius: 12px;
        // z-index: 2;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        .guide-text {
          // display: flex;
          // flex-direction: column;
          // align-items: center;
          .title {
            font-size: 21px;
            // color: #333;
            // font-weight: 600;
          }
        }

        > .qr-cpde-content {
          // display: flex;
          // align-items: center;
          // justify-content: space-between;
          margin-top: 38px;
          padding: 0 20px;
          margin-bottom: 63px;
          .qr-code-wrap {
            width: 180px;
            height: 180px;
            // border-radius: 10px;
            // border: 2px solid #e9e9e9;
            padding: 10px;
            .qr-code-img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .login-other {
          margin-top: 33px;
          .login-one {
            display: flex;
            align-items: center;
            cursor: pointer;
            .icon {
              font-size: 13px;
            }
            p {
              font-size: 12px;
              margin-left: 6px;
            }
          }
          .login-two {
            display: flex;
            align-items: center;
            margin: 0 10px;
            cursor: pointer;
            .icon {
              font-size: 13px;
            }
            p {
              font-size: 12px;
              margin-left: 6px;
            }
          }
          .login-three {
            display: flex;
            align-items: center;
            cursor: pointer;
            img {
              width: 16px;
              height: 16px;
            }
            p {
              font-size: 12px;
              margin-left: 6px;
            }
          }
        }
      }
      .qr-code-login-scan-panel {
        padding: 38px 42px;
        border-radius: 10px;
        width: 360px;
        height: 430px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 4;
        .success-cell {
          display: flex;
          flex-direction: column;
          align-items: center;

          .icon-chenggongtishi {
            color: #20d76d;
            font-size: 87px;
          }
          .status {
            color: #555;
            font-size: 20px;
            font-weight: 500;
          }
          .des {
            font-size: 18px;
            color: #555;
            margin-top: 10px;
          }
        }
        .qr-code-login-panelB {
          background-color: #fff;
          z-index: 5;
          display: flex;
          flex-direction: column;
          align-items: center;
          .guide-text {
            display: flex;
            flex-direction: column;
            align-items: center;
            .title {
              font-size: 21px;
              color: #333;
              font-weight: 600;
            }
          }

          > .qr-cpde-content {
            // display: flex;
            // align-items: center;
            // justify-content: space-between;
            margin-top: 38px;
            padding: 0 20px;
            margin-bottom: 45px;
            .qr-code-wrap {
              position: relative;
              width: 180px;
              height: 180px;
              border-radius: 10px;
              border: 2px solid #e9e9e9;
              padding: 10px;
              opacity: 0.1;
              .qr-code-img {
                width: 100%;
                height: 100%;
              }
            }
            .qr-code-wrapA {
              position: absolute;
              width: 180px;
              height: 180px;
              border-radius: 10px;
              border: 2px solid #e9e9e9;
              padding: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              .text-content {
                font-size: 14px;
                color: #333333;
              }
              .text-refesh {
                font-size: 14px;
                color: #4f98fd;
                cursor: pointer;
              }
            }
          }
          > .login-edit {
            // width: 300px;
            // width: 100%;
            // margin: 0 auto;
            // .el-divider {
            //   background-color: #e9e9e9;
            //   .el-divider__text {
            //     font-size: 14px;
            //     color: #666666;
            //     font-weight: normal;
            //   }
            // }
          }
          .login-other {
            display: flex;
            justify-content: space-between;
            margin-top: 3px;
            .login-one {
              display: flex;
              align-items: center;
              cursor: pointer;
              .icon {
                font-size: 13px;
              }

              p {
                font-size: 12px;
                font-weight: normal;
                color: #666666;
                margin-left: 6px;
              }
            }
            .login-two {
              display: flex;
              align-items: center;
              margin: 0 10px;
              cursor: pointer;
              .icon {
                font-size: 13px;
              }
              p {
                font-size: 12px;
                font-weight: normal;
                color: #666666;
                margin-left: 6px;
              }
            }
            .login-three {
              display: flex;
              align-items: center;
              cursor: pointer;
              img {
                width: 17px;
                height: 14px;
              }
              p {
                font-size: 12px;
                font-weight: normal;
                color: #666666;
                margin-left: 6px;
              }
            }
          }
        }
       
      }
    }
  }
}

.dev-select-server {
  position: fixed;
  right: 0px;
  top: 0px;
  background-color: red;
  padding: 20px,
}
</style>

